_updateUserInfo